import { render, staticRenderFns } from "./PortalBranding.vue?vue&type=template&id=7f47b5ca&"
import script from "./PortalBranding.vue?vue&type=script&lang=js&"
export * from "./PortalBranding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports